import React from "react";
import { Breadcrumb } from "@softura/fluentuipackage";

import "./breadcrumb.scss";

const breadcrumbStyles = {
  root: {
    margin: 0,
    fontSize: '12px'
  },
};

const Breadcrumbs = (props: any) => {
  return (
    <Breadcrumb
      items={props.items}
      maxDisplayedItems={5}
      styles={breadcrumbStyles}
    />
  );
};

export default Breadcrumbs;
